var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isFirstLoading)?_c('div',{staticClass:"related-list-layout"},[_c('ul',{staticClass:"related-list"},_vm._l((_vm.relatedCellList),function(thumb,index){return _c('li',{key:`related_thumb_${index}`,staticClass:"item"},[_c('RelatedCell',{attrs:{"thumb":thumb}})],1)}),0)]):_vm._e(),_c('div',{ref:"scrollMonitor"})])
}
var staticRenderFns = []

export { render, staticRenderFns }